import { ModelBase } from './base';
import { Address } from './address';

export class Customer extends ModelBase {
  first_name: string;
  last_name: string;
  username: string;
  gender?: any;
  birthdate?: any;
  prefered_language?: any;
  discriminator: string;
  external_reference?: any;
  contact_details_id: string;
  role_id: string;
  is_active: any;
  contact_details: Contactdetails;
}

export class Contactdetails extends ModelBase {
  phone: string;
  mail: string;
  addresses: Address[];
}

export class CustomerGroup extends ModelBase {
  can_see_price: boolean;
  can_see_contact_page: boolean;
  can_see_home_page: boolean;
  can_see_product_page: boolean;
  can_see_news_page: boolean;
  can_submit_order: boolean;
  discount: number;
  needs_login: boolean;
}


// WEBPACK FOOTER //
// ./src/models/customer.ts